import { useState, useEffect } from 'react'

/**
 * Filters array of reviews by array of strings.
 * @param {object} reviewObj - array of reviews to filter
 * @param {string} keywordStr - text to filter reviews by.
 * @returns {array} all reviews containing string(s).
 */
const filterByText = (reviewObj, keywordStr) => {
  // converts test to lowercase and splits text by space
  const keywords = keywordStr.toLowerCase().split(' ')

  const { title, review } = reviewObj

  // Checks if title/review includes all keywords.
  return keywords.every(keyword =>
    [title, review]
      .join(' ')
      .toLowerCase()
      .includes(keyword)
  )
}

/**
 * This hook takes an array of reviews, and returns a function to set the filter settings.
 * @param {array} reviews - array of reviews to filter
 * @returns {array} returns an array of arrays and functions.
 * filteredReviews - the filtered reviews
 * setFilters - Function that sets filters, must be an object
 * setItems - sets the reviews array that can be filtered
 */
export const useReviewFilter = (reviews = []) => {
  const [filteredReviews, setFilteredReviews] = useState([])
  const [filters, setFilters] = useState({ keywords: '', rating: '' })
  const { keywords, rating } = filters

  useEffect(() => {
    setFilteredReviews(() => (
      (reviews ? [...reviews] : [])
        .filter(review => filterByText(review, keywords))
        .filter(review => !rating || rating === 10 || review.rating === rating)
    ))
  }, [reviews, filters])

  return [filteredReviews, setFilters, filters]
}
